import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GeographyService } from '@app/_services';
import { Subscription } from 'rxjs';
import { County, State, Country } from '../../_models/signups/geography';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { Education, Employer, levelOfEducation, orderType } from '@app/_models';
import { BirthdayValidator, EmptyStringValidator, MustMatch } from '@app/_helpers';
import { FadvDatePickerComponent } from '@fa-switch-sharedservices/ng-elements';
import { CreditCheck } from '@app/_models/creditCheck';

@Component({
  selector: 'app-baseorder',
  templateUrl: './baseorder.component.html',
  styleUrls: ['./baseorder.component.less']
})
export class BaseorderComponent implements OnInit {

  requireDL = false;
  requireMiddleName = false;
  middleNameToggle: Subscription;
  selectedState: string;
  selectedCounty: string;
  states: State[] = [];
  countries: Country[] = [];
  counties: County[] = [];
  previousAddresses: string[] = [];
  previousEmployers: Employer[] = [];
  form: UntypedFormGroup;
  inviteForm: UntypedFormGroup;
  typeOfOrder: string;
  orderType = orderType;
  employmentRequired= false;
  educationRequired = false;
  institutions: Education[] = [];
  creditChecks: CreditCheck[] = [];
  levelsOfEducation: any;
  educationFormInvalid: boolean;
  employmentFormInvalid: boolean;
  hasIncludedEmployment: boolean;
  hasIncludedEducation: boolean;
  hasIncludedCredit: boolean;

  constructor(public geographyService: GeographyService, 
      public formBuilder: UntypedFormBuilder) {

      this.form = this.formBuilder.group({
        
        order: this.formBuilder.group({
  
          // haveSignedRelease: [false, [Validators.requiredTrue]],
          // releaseCheckBox: new FormControl(),

          candidate: this.formBuilder.group({
            firstName: ['', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
            middleNameRequired: [''],
            middleName: [''],
            lastName: ['', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
            ssn: ['', [Validators.required, Validators.minLength(9), Validators.pattern(/^-?(|[0-9]\d*)?$/), EmptyStringValidator]], 
            dob: ['', [Validators.required, BirthdayValidator]],
            email: ['', [Validators.required, Validators.email]],
            confirmEmail: ['', Validators.required],
            dlNumber: [''],
            dlState: ['']      
          }, { validator:  MustMatch('email', 'confirmEmail')}),
          currentAddress: this.formBuilder.group({
            addressLine1: ['', [Validators.required, EmptyStringValidator]],
            addressLine2: [''],
            county: ['', [Validators.required]],
            zip: ['', [Validators.required, Validators.minLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]],
            city: ['', [Validators.required, EmptyStringValidator]],
            state: ['', [Validators.required, Validators.pattern('[a-z A-Z]+$'), EmptyStringValidator]],
            country: ['US', [Validators.required]],
          }),
          employment: this.formBuilder.group({
              employerName: [''],
              startDate: [''],
              endDate: [''],
              position: [''],
              city: [''],
              state: [''],
              phone: [''],
              isCurrentEmployer: false
          }),
          education: this.formBuilder.group({
            institutionName: [''],
            startDate: [Date],
            endDate: [Date],
            levelOfEducation: [''],
            city: [''],
            state: [''],
            fieldOfStudy: [''],
            nameAttendedUnder: [''],
            typeOfDegree: [''],
            acquiredDegree: false,
            dateAwarded: ['']
          }),
          previousAddress: ['']
        })
      });

      this.middleNameToggle = this.candidate.get('middleNameRequired').valueChanges.subscribe(x => {
        this.requireMiddleName = x === '1';
        if (this.requireMiddleName) {
          this.candidate.controls.middleName.addValidators(Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'));
          this.candidate.controls.middleName.addValidators(EmptyStringValidator);
        } 
        else {
          this.candidate.controls.middleName.removeValidators(Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'));
          this.candidate.controls.middleName.removeValidators(EmptyStringValidator);
        } 
        this.candidate.controls.middleName.updateValueAndValidity();
      });
      this.handlePreviousAddressValidation();
  }

  get orderForm() { return this.form.get('order') as UntypedFormGroup };
  get candidate() { return this.orderForm.get('candidate') as UntypedFormGroup };
  get currentAddress() { return this.orderForm.get('currentAddress') as UntypedFormGroup };
  get employment() {return this.orderForm.get('employment') as UntypedFormGroup };
  get education() {return this.orderForm.get('education') as UntypedFormGroup };

  handleZipCodeChange(zip: string) {
    this.geographyService.getStatesByPostalCode(zip).subscribe(response => {
      this.selectedState = response[0]['name'];
      this.currentAddress.patchValue({ state: response[0]['name'] });
      // if(response[0] != undefined) {
      //   this.selectedState = response[0].name;
      //   this.form.patchValue({
      //   billToState: this.selectedState
      //   });
      // }
      // else
      // {
      //   this.form.patchValue({
      //     billToState: ''
      //   });
      // }
      
      this.geographyService.getCounties(zip, this.selectedState).subscribe(counties => {
        this.counties = counties;
        if (counties.length === 1) {
          this.currentAddress.patchValue({ county: this.counties[0].Key });
          this.selectedCounty = this.counties[0].Key;
        } 
      })
    });
  }

  handlePreviousAddressValidation(){
    if(this.orderForm.value.previousAddress != null)
    {
      this.orderForm.setControl("previousAddress", new UntypedFormControl('', [Validators.minLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]));
    }
  }

  setDob(dob: Date) {
    this.candidate.patchValue({ dob: new Date(dob) });
  }

  addPreviousAddress() {
    this.previousAddresses.push(this.orderForm.value.previousAddress);
    this.orderForm.patchValue({ previousAddress: ''});
  }

  removePreviousAddress(address: any) {
    this.previousAddresses = this.previousAddresses.filter(x => x != address);
  }

  addPreviousEmployer() {
    var inputEmployer = new Employer();

    inputEmployer = this.orderForm.get('employment').value;
    if (this.orderForm.get('employment').value.isCurrentEmployer) {
      inputEmployer.isCurrentEmployer = true;
    }
    else
    {
      inputEmployer.isCurrentEmployer = false;
    }
      this.previousEmployers.push(inputEmployer);
      this.orderForm.get('employment').reset();
      // this.removeEmploymentValidators();
      this.hasIncludedEmployment = true;
  }


  // removePreviousEmployer(employer: any) {
  //   this.previousEmployers = this.previousEmployers.filter(x => x != employer);
  //   this.checkEmploymentArray();
  // }

  setRequireDL() {
    this.requireDL = true;
    this.candidate.setControl("dlNumber", new UntypedFormControl('', [Validators.required, EmptyStringValidator]));
    this.candidate.setControl("dlState", new UntypedFormControl('', [Validators.required,Validators.pattern('^[a-zA-Z]+$'), EmptyStringValidator]));
    this.candidate.updateValueAndValidity();
  }

  addCreditCheck() {
    var inputCredit = new CreditCheck();
    inputCredit.FirstName = this.candidate.controls.firstName.value;
    inputCredit.LastName = this.candidate.controls.lastName.value;
    inputCredit.Address1 = this.currentAddress.controls.addressLine1.value;
    inputCredit.Address2 = this.currentAddress.controls.addressLine2.value;
    inputCredit.City = this.currentAddress.controls.city.value;
    inputCredit.State = this.currentAddress.controls.state.value;
    inputCredit.ZipCode = this.currentAddress.controls.zip.value;
    inputCredit.IDType = "SSN";
    inputCredit.IDNumber = this.candidate.controls.ssn.value;

    this.creditChecks.push(inputCredit);
    this.hasIncludedCredit = true;

  }

  addEducation() {
    var inputEducation = new Education();
    inputEducation = this.education.value;
    
    inputEducation.acquiredDegree = this.education.controls.acquiredDegree.value;

    if(inputEducation.acquiredDegree == false || inputEducation.acquiredDegree == null){
      inputEducation.dateAwarded = "Did not recieve degree";
      inputEducation.acquiredDegree = false;
    }
    else{
      inputEducation.acquiredDegree = true;
    }

    if(inputEducation.levelOfEducation != "College"){
      inputEducation.typeOfDegree = ""
    }

    this.institutions.push(inputEducation);
    this.orderForm.get('education').reset();
    // this.removeEducationValidators();
    this.hasIncludedEducation = true;
  }

  // removeEducation(values: any) {
  //   this.institutions = this.institutions.filter(x => x.institutionName != values[0].institutionName && x.levelOfEducation != values[0].levelOfEducation);
  //   this.checkEducationArray();
  // }

  diplomaAwarded(checked: boolean){
    this.education.controls.acquiredDegree.setValue(checked);
    if(checked == true)
    {
      this.education.controls.dateRecieved.addValidators([Validators.required]);
    }
    else
    {
      this.education.controls.dateRecieved.removeValidators([Validators.required]);
    }
}

setEmploymentValidators(){
  this.employment.controls.employerName.addValidators([Validators.required, EmptyStringValidator]);
  this.employment.controls.startDate.addValidators([Validators.required]);
  this.employment.controls.endDate.addValidators([Validators.required]);
  this.employment.controls.position.addValidators([Validators.required, EmptyStringValidator]);
  this.employment.controls.city.addValidators([Validators.required, EmptyStringValidator]);
  this.employment.controls.state.addValidators([Validators.required]);
  this.employment.controls.phone.addValidators([Validators.required, EmptyStringValidator, Validators.pattern(/^-?(|[0-9]\d*)?$/)]);
  this.employment.updateValueAndValidity();
}

setEducationValidators(){
  this.education.controls.institutionName.addValidators([Validators.required, EmptyStringValidator]);
  this.education.controls.nameAttendedUnder.addValidators([Validators.required, EmptyStringValidator]);
  this.education.controls.startDate.addValidators([Validators.required]);
  this.education.controls.endDate.addValidators([Validators.required]);
  this.education.controls.levelOfEducation.addValidators([Validators.required]);
  this.education.controls.fieldOfStudy.addValidators([Validators.required, EmptyStringValidator]);
  this.education.controls.state.addValidators([Validators.required]);
  this.education.controls.city.addValidators([Validators.required, EmptyStringValidator]);
  this.education.updateValueAndValidity();
}


checkEmploymentArray(){
  if(this.previousEmployers.length != 0)
  {
    // this.removeEmploymentValidators();
    this.hasIncludedEmployment = true;
  }
  else
  {
    // this.setEmploymentValidators();
    this.hasIncludedEmployment = false;
  }
  }
  
  checkEducationArray(){
    if(this.institutions.length != 0)
    {
      // this.removeEducationValidators();
      this.hasIncludedEducation = true;
    }
    else
    {
      // this.setEducationValidators();
      this.hasIncludedEducation = false;
    }
  }

  // handleEmploymentCancel(){
  //   this.orderForm.get('employment').reset();
  //   // this.removeEmploymentValidators();
  // }

  // handleEducationCancel(){
  //   this.orderForm.get('education').reset();
  //   // this.removeEducationValidators();
  // }


  removeEmploymentValidators(){
    this.employment.setControl("employerName", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("startDate", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("endDate", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("position", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("state", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("city", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("phone", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.updateValueAndValidity();
  }
  
  removeEducationValidators(){
      this.education.setControl("institutionName", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("nameAttendedUnder", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("startDate", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("endDate", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("levelOfEducation", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("fieldOfStudy", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("state", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("city", new UntypedFormControl({ value: '', disabled: false }));
      this.education.setControl("dateRecieved", new UntypedFormControl({ value: '', disabled: false }));
      this.education.updateValueAndValidity();
  }


  ngOnInit(): void {
    this.levelsOfEducation = levelOfEducation;
  }
}
